import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { Link } from '../../../../models/link';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { AuthService } from '../../../core/services/auth.service';
import { LinkService } from '../../../../services/link.service';
import { DialogService } from '../../../../services/dialog.service';
import { ToastService } from '../../../../services/toast.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-adm-link',
  templateUrl: './adm-link.component.html',
  styleUrls: ['./adm-link.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AdmLinkComponent implements OnInit {
  displayedColumns: string[] = ['id', 'site', 'url', 'actions'];
  dataSource: any = [];

  public links: Link[];
  public link: Link;
  submitted = false;
  error = '';

  active: boolean = false;
  saving: boolean = false;
  formLink: UntypedFormGroup;

  constructor(
    private authorizeService: AuthService,
    private modalService: NgbModal,
    private linkService: LinkService,
    private dialogService: DialogService,
    private toastService: ToastService,
    private router: Router
  ) { }

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  ngOnInit() {
    var user = this.authorizeService.getUser();
    if (user != null) {
      this.loadGrid();
      this.createForm(new Link());
    } else {
      this.router.navigate(['/login'], {
        queryParams: { retUrl: '/adm/link' }
      });
    }
  }

  get f() {
    return this.formLink.controls;
  }

  loadGrid() {
    this.linkService.get().subscribe((res) => {
      this.dataSource = new MatTableDataSource(res);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });
  }

  createForm(linkForm: Link) {
    this.formLink = new UntypedFormGroup({
      id: new UntypedFormControl(linkForm.id),
      site: new UntypedFormControl(linkForm.site, Validators.required),
      descricao: new UntypedFormControl(linkForm.descricao),
      imagem: new UntypedFormControl(linkForm.imagem, Validators.required),
      url: new UntypedFormControl(linkForm.url, Validators.required),
    });
  }

  open(content: any) {
    this.createForm(new Link());
    this.modalService.open(content);
    this.submitted = false;
  }

  edit(content: any, id: number) {
    this.submitted = false;
    this.linkService.getById(id).subscribe((res) => {
      this.link = res;
      this.formLink.setValue({
        id: this.link.id,
        site: this.link.site,
        descricao: this.link.descricao,
        imagem: this.link.imagem,
        url: this.link.url,
      });
    });
    this.modalService.open(content);
  }

  async deleteItem(id: number): Promise<void> {
    this.active = true;

    const confirmado = await this.dialogService.confirm('Deseja realmente excluir?', 'Tem certeza?');

    if (confirmado) {
      this.linkService.delete(id).subscribe({
        next: (res: any) => {
          this.toastService.show('Link excluído', { type: 'success' });
          this.loadGrid();
        },
        error: (err) => {
          this.toastService.show('Não foi possível excluir!', { type: 'danger' });
        },
      });
    }
  }

  create(content: any): void {
    this.createForm(new Link());
    this.modalService.open(content);
  }

  submitForm() {
    this.submitted = true;

    if (this.formLink.invalid) {
      this.error = 'Informações inválidas';
      return;
    }
    this.link = this.formLink.value;
    if (this.link.id > 0) {
      this.linkService.put(this.link.id, this.link).subscribe({
        next: (res) => {
          this.link = res;
          this.loadGrid();
          this.toastService.show('Link editado com sucesso!', { type: 'success' });
          this.modalService.dismissAll();
        },
        error: () => {
          this.toastService.show('Erro ao editar!', { type: 'danger' });
        },
      });
    } else {
      this.link.id = 0;
      this.linkService.post(this.link).subscribe({
        next: (res) => {
          this.toastService.show('Link criado com sucesso!', { type: 'success' });
          this.loadGrid();
          this.modalService.dismissAll();
        },
        error: () => {
          this.toastService.show('Erro ao criar!', { type: 'danger' });
        },
      });
    }
  }

  confirmBox() { }
}
